import { render } from "./App.vue?vue&type=template&id=ab6d7912"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ab6d7912&lang=scss"
import "./App.vue?vue&type=style&index=1&id=ab6d7912&lang=css"

import exportComponent from "D:\\Code\\基家织品\\企微助手\\备份\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__